import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import format from 'date-fns/format';

import LoadingCube from 'sub_components/Common/LoadingCube';
import { UserApi } from 'services/user';
import { DataCenterApi } from 'services/datacenter';
import ScrollView from 'sub_components/Common/BloxScrollViewNew';

const BadgeDetails = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 408px;
	height: 100%;
	color: ${props => props.theme.defaultFontColor};
	.buttons {
		position: absolute;
		bottom: 16px;
		width: 100%;
		display: flex;
		justify-content: space-around;
	}
	.main-display {
		width: 100%;
		height: 240px;
		display: flex;
		justify-content: center;
		flex-direction: row;
		flex-wrap: wrap;
		#action-button {
			margin: 25px;
		}
		.ScrollbarsCustom-Track {
			right: 12px !important;
			top: 0px !important;
		}
		.ScrollbarsCustom-ThumbY {
			background-color: ${props => props.theme.account} !important;
			width: 6px !important;
		}
		.ScrollbarsCustom-TrackY:before {
			border-left: none;
		}
		.ScrollbarsCustom-TrackY {
			background-color: ${props => props.theme.Cool_Gray_Light_2} !important;
			box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
				1px 1px 1.5px ${props => props.theme.Cool_Gray_Med_2} inset;
			width: 6px !important;
		}
	}

	.divider {
		width: 100%;
		height: 2px;
		border-radius: 15px;
		background-color: ${props => props.theme.Cool_Gray_Light_3};
		box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
			1px 1px 1.5px ${props => props.theme.boxShadow} inset;
	}

	.info-display {
		width: 272px;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		.header {
			display: flex;
			height: 70px;
			align-items: center;
		}
		.main-info {
			height: 130px;
			display: flex;
			flex-direction: column;
			padding-left: 15px;
			.main-title {
				margin-top: 10px;
				margin-bottom: 10px;
			}
			.field {
				display: flex;
				flex-direction: row;
				.label {
					width: 70px;
				}
				.value {
					width: 135px;
				}
			}
		}
		.main-footer {
			display: flex;
			height: 50px;
			justify-content: center;
			align-items: center;
		}
	}
	.section {
		width: 100%;
		height: 160px;
		margin-top: 10px;

		&.large {
			height: 200px;
		}

		.main-footer {
			display: flex;
			height: 50px;
			justify-content: center;
			align-items: center;
		}

		.log-details-wrapper {
			width: 100%;
			height: 100%;
			display: flex;
			flex-direction: column;

			.log-headings {
				width: 100%;
				min-height: 24px;
				display: flex;
				margin-bottom: 9px;
				.log-header {
					margin-right: 16px;
					display: flex;
					align-items: flex-end;
					text-align: left;
					background-color: ${props => props.theme.Cool_Gray_Med_3};
					&.username {
						width: 56px;
					}
					&.description {
						width: 160px;
					}
					&.city {
						width: 32px;
					}
					&.date,
					&.time {
						width: 48px;
					}
				}
			}
			.log-row {
				display: flex;
				width: 100%;
				height: 16px;
				margin-bottom: 9px;

				.log-body {
					margin-right: 16px;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
					background-color: ${props => props.theme.Cool_Gray_Med_3};
					&.username {
						width: 56px;
					}
					&.description {
						width: 160px;
					}
					&.city {
						width: 32px;
					}
					&.date,
					&.time {
						width: 48px;
					}
				}
			}
		}
	}

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		color: ${props => props.theme.defaultFontColor};
		width: 448px;
		height: 100%;
		.buttons {
			position: absolute;
			bottom: 16px;
		}
		.main-display {
			width: 500px;
			height: 340px;
			padding: 50px #action-button {
				margin: 25px;
			}
			.ScrollbarsCustom-Track {
				right: -38px !important;
				top: 0px !important;
			}

			.ScrollbarsCustom-ThumbY {
				width: 8px !important;
			}
			.ScrollbarsCustom-TrackY {
				width: 8px !important;
			}
		}

		.divider {
			width: 100%;
			height: 2px;
			border-radius: 15px;
			background-color: ${props => props.theme.Cool_Gray_Light_3};
			box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
				1px 1px 1.5px ${props => props.theme.boxShadow} inset;
		}

		.info-display {
			width: 372px;
			height: 100%;

			.header {
				display: flex;
				height: 70px;
				align-items: center;
			}
			.main-info {
				height: 130px;
				display: flex;
				flex-direction: column;
				padding-left: 15px;
				.main-title {
					margin-top: 10px;
					margin-bottom: 10px;
				}
				.field {
					display: flex;
					flex-direction: row;
					.label {
						width: 70px;
					}
					.value {
						width: 135px;
					}
				}
			}
			.main-footer {
				display: flex;
				height: 50px;
				justify-content: center;
				align-items: center;
			}
		}
		.section {
			width: 500px;
			min-height: 240px;
			margin-top: 20px;
			margin-left: 50px;

			&.large {
				min-height: 280px;
			}

			.main-footer {
				display: flex;
				height: 50px;
				justify-content: center;
				align-items: center;
			}

			.log-details-wrapper {
				width: 100%;
				height: 100%;
				display: flex;
				flex-direction: column;
				padding-left: 30px;
				padding-top: 20px;

				.log-headings {
					width: 100%;
					min-height: 24px;
					display: flex;
					margin-bottom: 9px;
					.log-header {
						margin-right: 16px;
						display: flex;
						align-items: flex-end;
						text-align: left;
						background-color: ${props => props.theme.Cool_Gray_Med_3};
						&.username {
							width: 76px;
						}
						&.description {
							width: 180px;
						}
						&.city {
							width: 52px;
						}
						&.date,
						&.time {
							width: 68px;
						}
					}
				}
				.log-row {
					display: flex;
					width: 100%;
					height: 16px;
					margin-bottom: 9px;

					.log-body {
						margin-right: 16px;
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
						background-color: ${props => props.theme.Cool_Gray_Med_3};
						&.username {
							width: 76px;
						}
						&.description {
							width: 180px;
						}
						&.city {
							width: 52px;
						}
						&.date,
						&.time {
							width: 68px;
						}
					}
				}
			}
		}
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		width: 950px;
		.buttons {
			position: absolute;
			bottom: 16px;
		}
		.main-display {
			width: 850px;
			height: 340px;

			padding: 80px #action-button {
				margin: 25px;
			}
			.ScrollbarsCustom-Track {
				right: -42px !important;
				top: 0px !important;
			}

			.ScrollbarsCustom-ThumbY {
				width: 10px !important;
			}
			.ScrollbarsCustom-TrackY {
				width: 10px !important;
			}
		}

		.divider {
			width: 100%;
			height: 2px;
			border-radius: 15px;
			background-color: ${props => props.theme.Cool_Gray_Light_3};
			box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
				1px 1px 1.5px ${props => props.theme.boxShadow} inset;
		}

		.info-display {
			width: 372px;
			height: 100%;

			.header {
				display: flex;
				height: 70px;
				align-items: center;
			}
			.main-info {
				height: 130px;
				display: flex;
				flex-direction: column;
				padding-left: 15px;
				.main-title {
					margin-top: 10px;
					margin-bottom: 10px;
				}
				.field {
					display: flex;
					flex-direction: row;
					.label {
						width: 70px;
					}
					.value {
						width: 135px;
					}
				}
			}
			.main-footer {
				display: flex;
				height: 100px;
				justify-content: center;
				align-items: center;
			}
		}
		.section {
			width: 850px;
			min-height: 280px;
			margin-top: 10px;

			&.large {
				height: 300px;
			}

			.main-footer {
				display: flex;
				height: 100px;
				justify-content: center;
				align-items: center;
			}

			.log-details-wrapper {
				width: 100%;
				height: 100%;
				display: flex;
				flex-direction: column;

				.log-headings {
					width: 100%;
					min-height: 34px;
					display: flex;
					margin-bottom: 12px;
					.log-header {
						margin-right: 36px;
						display: flex;
						align-items: flex-end;
						text-align: left;
						background-color: ${props => props.theme.Cool_Gray_Med_3};
						&.username {
							min-width: 206px;
						}
						&.description {
							min-width: 210px;
						}
						&.city {
							min-width: 82px;
						}
						&.date,
						&.time {
							min-width: 98px;
						}
					}
				}
				.log-row {
					display: flex;
					width: 100%;
					height: 26px;
					margin-bottom: 9px;

					.log-body {
						margin-right: 36px;
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
						background-color: ${props => props.theme.Cool_Gray_Med_3};
						&.username {
							min-width: 206px;
						}
						&.description {
							min-width: 210px;
						}
						&.city {
							min-width: 82px;
						}
						&.date,
						&.time {
							min-width: 98px;
						}
					}
				}
			}
		}
	}
`;
function renderBadgeHeader(badges, role) {
	const badgesFormatted = badges.map(badge => {
		const accessLogs = badge?.dataCenterUserAccessLogList;
		return (
			<div className='log-details-wrapper'>
				{role === 'member' && (
					<>
						<div className='log-headings'>
							<div className='log-header username '>
								<div className='title labels21'>BADGE</div>
							</div>
							<div className='log-header description '>
								<div className='title labels21'>MESSAGE</div>
							</div>
							<div className='log-header city '>
								<div className='title labels21'>CITY</div>
							</div>
							<div className='log-header date '>
								<div className='title labels21'>DATE</div>
							</div>
							<div className='log-header time '>
								<div className='title labels21'>TIME</div>
							</div>
						</div>
						<div className='log-body'>
							{accessLogs && renderBadgeDetails(accessLogs, badge)}
							{accessLogs.length === 0 && (
								<div className='body10'>No access records to display.</div>
							)}
						</div>
					</>
				)}
			</div>
		);
	});
	return badgesFormatted;
}

function renderBadgeDetails(logs, badge) {
	return (
		<>
			{logs &&
				logs.map(log => {
					const date = format(new Date(log?.messageDT), 'MM-dd-yy');
					const time = format(new Date(log?.messageDT), 'HH:mm a');
					return (
						<div className='log-row'>
							<div className='log-body username body10'>{badge?.badgeId}</div>
							<div className='log-body description body10'>{log?.messageType}</div>
							<div className='log-body city body10'>{log?.datacenter}</div>
							<div className='log-body date body10'>{date}</div>
							<div className='log-body time body10'>{time}</div>
						</div>
					);
				})}
		</>
	);
}
function renderBadgeLogsOwner(logs) {
	return (
		<div className='log-body'>
			{logs &&
				logs.map(log => {
					const date = format(new Date(log?.messageDT), 'MM-dd-yy');
					const time = format(new Date(log?.messageDT), 'HH:mm a');
					return (
						<div className='log-row'>
							<div className='log-body username body10'>{log?.cardNumber}</div>
							<div className='log-body description body10'>{log?.messageType}</div>
							<div className='log-body city body10'>{log?.dataCenter}</div>
							<div className='log-body date body10'>{date}</div>
							<div className='log-body time body10'>{time}</div>
						</div>
					);
				})}
			{logs.length === 0 && <div className='body10'>No Data Center access logs to display.</div>}
		</div>
	);
}

export const BadgeAccess = ({
	//onClick,
	role,
	organizationId,
	rosterUser,
	user,
	//hasDownloadDocumentAccess,
}) => {
	const [badges, setBadges] = useState([]);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		if (role === 'owner') {
			UserApi.getOrgDataCenterAccess(organizationId, user?.id)
				.then(response => {
					const validResponse = response.status === 200 && response.data;

					if (validResponse) {
						setBadges(response.data?.dataCenterUserAccessLogs);
						setIsLoading(false);
					} else {
						//this.setState({ error: 'Error getting badge details' });
					}
				})
				.catch(() => {});
		} else {
			const params = {
				rosterUserId: rosterUser?.id,
			};
			DataCenterApi.getBadgeDetails(params)
				.then(response => {
					const validResponse = response.status === 200 && response.data;
					if (validResponse) {
						setBadges(response.data?.badges);
						setIsLoading(false);
					} else {
					}
				})
				.catch(() => {});
		}
	}, [setBadges]);
	return (
		<BadgeDetails>
			<div className='main-display'>
				{isLoading && <LoadingCube />}
				{badges && !isLoading && (
					<div className={role !== 'owner' ? 'section' : 'section large'}>
						{role === 'member' && <ScrollView>{renderBadgeHeader(badges, role)}</ScrollView>}
						{role === 'owner' && (
							<>
								<div className='log-details-wrapper'>
									<div className='log-headings'>
										<div className='log-header username '>
											<div className='title labels21'>BADGE</div>
										</div>
										<div className='log-header description '>
											<div className='title labels21'>MESSAGE</div>
										</div>
										<div className='log-header city '>
											<div className='title labels21'>CITY</div>
										</div>
										<div className='log-header date '>
											<div className='title labels21'>DATE</div>
										</div>
										<div className='log-header time '>
											<div className='title labels21'>TIME</div>
										</div>
									</div>
									<ScrollView>{renderBadgeLogsOwner(badges)}</ScrollView>
								</div>
							</>
						)}
						<div className='divider'></div>
						<div className='main-footer'>
							{/* {hasDownloadDocumentAccess && (
								<BloxButton
									id={'notifications-button'}
									text='DOWNLOAD'
									onClick={onClick}
									module='account'
									enabled={true}
									className='buttons41'
								/>
							)} */}
						</div>
					</div>
				)}
			</div>
		</BadgeDetails>
	);
};
// LargeInfoDisplay.propTypes = {
// 	type: string.isRequired,
// };

// LargeInfoDisplay.defaultProps = {};
